export default __webpack_public_path__ + "static/broschuere-kuhmichel-4b34b943202f581dce0b3f750a56cbd1.jpg";